import { useTranslation } from "react-i18next";
import Dialog from "src/components/Dialog";

export default function SeeMeAlreadyRunningDialog({ isOpen, onDismiss }) {
  const { t } = useTranslation();
  return (
    <Dialog
      isOpen={isOpen}
      heading={t("parentStation.seeMeAlreadyRunningDialog.heading")}
      text={t("parentStation.seeMeAlreadyRunningDialog.text")}
      buttons={[
        {
          text: t("buttons.ok"),
          onClick: onDismiss
        }
      ]}
    />
  );
}
